import Vue from "vue";
import Vuex from "vuex";
import { viagens } from "./modules/viagens";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    viagens,
  },
});
